import React from "react";
import {
  Box,
  Button,
  Container,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Image,
  Link,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { company, contact, navLinks } from "../data/content";

const MenuIcon = () => (
  <Box as="svg" viewBox="0 0 24 24" w="24px" h="24px" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 6h18M3 12h18M3 18h18" strokeLinecap="round" />
  </Box>
);

const PhoneIcon = (props) => (
  <Box as="svg" viewBox="0 0 24 24" w="16px" h="16px" fill="currentColor" {...props}>
    <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.4.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.4 0 .7-.2 1l-2.3 2.2z" />
  </Box>
);

export default function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box
      as="header"
      position="sticky"
      top={0}
      zIndex="sticky"
      bg="rgba(255,255,255,0.85)"
      backdropFilter="saturate(180%) blur(12px)"
      borderBottom="1px solid"
      borderColor="ink.100"
    >
      <Container maxW="6xl" px={{ base: 5, md: 8 }}>
        <Flex h="64px" align="center" justify="space-between" gap={4}>
          <Link
            href="#top"
            display="flex"
            alignItems="center"
            gap={3}
            _hover={{ textDecoration: "none" }}
            minW={0}
          >
            <Image
              src={`${process.env.PUBLIC_URL}/company_logo.jpg`}
              alt=""
              boxSize="36px"
              borderRadius="full"
              objectFit="cover"
              flexShrink={0}
            />
            <Text
              fontWeight={700}
              fontSize="sm"
              lineHeight="1.2"
              noOfLines={2}
              display={{ base: "none", sm: "block" }}
            >
              {company.name}
            </Text>
          </Link>

          <HStack as="nav" spacing={7} display={{ base: "none", lg: "flex" }}>
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                fontSize="sm"
                fontWeight={500}
                color="ink.600"
                _hover={{ color: "ink.900" }}
              >
                {link.label}
              </Link>
            ))}
          </HStack>

          <HStack spacing={2} flexShrink={0}>
            <Button
              as="a"
              href={contact.phoneHref}
              variant="brand"
              size="sm"
              leftIcon={<PhoneIcon />}
              display={{ base: "none", sm: "inline-flex" }}
            >
              {contact.phoneDisplay}
            </Button>
            <IconButton
              as="a"
              href={contact.phoneHref}
              aria-label={`Call ${contact.phoneDisplay}`}
              icon={<PhoneIcon />}
              variant="brand"
              size="sm"
              display={{ base: "inline-flex", sm: "none" }}
            />
            <IconButton
              aria-label="Open menu"
              icon={<MenuIcon />}
              onClick={onOpen}
              variant="outlineInk"
              size="sm"
              display={{ base: "inline-flex", lg: "none" }}
            />
          </HStack>
        </Flex>
      </Container>

      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottom="1px solid" borderColor="ink.100">
            Menu
          </DrawerHeader>
          <DrawerBody>
            <VStack align="stretch" spacing={0} pt={2}>
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  onClick={onClose}
                  py={3}
                  fontSize="lg"
                  fontWeight={500}
                  borderBottom="1px solid"
                  borderColor="ink.100"
                  _hover={{ color: "brand.600" }}
                >
                  {link.label}
                </Link>
              ))}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
}
